import React from "react"
import type {CardLevelLimits, CardTotals, CardLimitOverrideInfo} from "../../../../resources/account"
import {LimitOverrideType} from "../../../../resources/account"
import RangeBox from "../../../../components/RangeBox/RangeBox"
import {LimitsPageBlockHeader} from "../LimitsPageBlockHeader"
import {buildCardOverrideInfoProp, getEffectiveCardLimit} from "../helpers"

const cardLimitItems: {
	title: string
	overrideType: LimitOverrideType
	limitKey: keyof CardLevelLimits
	totalKey: keyof CardTotals
}[] = [
	{
		title: "Purchases",
		overrideType: LimitOverrideType.CardDailyPurchase,
		limitKey: "dailyPurchase",
		totalKey: "purchases",
	},
	{
		title: "Transaction",
		overrideType: LimitOverrideType.CardDailyTransaction,
		limitKey: "dailyCardTransaction",
		totalKey: "cardTransactions",
	},
	{
		title: "ATM deposit",
		overrideType: LimitOverrideType.CardDailyDeposit,
		limitKey: "dailyDeposit",
		totalKey: "deposits",
	},
	{
		title: "ATM Withdrawal",
		overrideType: LimitOverrideType.CardDailyWithdrawal,
		limitKey: "dailyWithdrawal",
		totalKey: "withdrawals",
	},
]

export function CardLimitsSection({
	limits,
	total,
	override,
}: {
	limits: CardLevelLimits
	total: CardTotals
	override?: CardLimitOverrideInfo
}) {
	return (
		<div className="account-limits-page-section">
			<LimitsPageBlockHeader
				title="Card Limits"
				icon="credit-card-money-fund--business-products"
				infoTip="This limit is based on the limit set in the deposit product"
			/>

			<div className="account-limits-page-grid">
				{cardLimitItems.map(({title, overrideType, limitKey, totalKey}) => (
					<RangeBox
						key={overrideType}
						title={title}
						description="(Daily Limit)"
						className="account-limits-page-range-box"
						max={getEffectiveCardLimit(limits[limitKey], override, overrideType)}
						current={total[totalKey]}
						overrideInfo={buildCardOverrideInfoProp(override, overrideType, limits[limitKey])}
					/>
				))}
			</div>
		</div>
	)
}
